package app.nestbridge.feature.profile.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object ProfileScreen : Screen

data class ProfileState(
    val displayName: String,
    val pingResult: String?,
    val passkeySupported: Boolean = false,
    val passkeyStatus: String? = null,
    val eventSink: (ProfileEvent) -> Unit,
) : CircuitUiState

sealed interface ProfileEvent {
    data object BackClicked : ProfileEvent
    data object LogoutClicked : ProfileEvent
    data object SetupPasskey : ProfileEvent

    // Temporary Dev Tools
    data object PingNoAuth : ProfileEvent
    data object PingJwt : ProfileEvent
    data object PingSessionToken : ProfileEvent
    data object ShowDesignCatalog : ProfileEvent
}
